"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormTouristsPicker = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _TouristsPicker = _interopRequireDefault(require("../TouristsPicker"));

var _context = require("../../context");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FormTouristsPicker = function FormTouristsPicker(_ref) {
  var name = _ref.name,
      className = _ref.className,
      variant = _ref.variant,
      isOpenInitial = _ref.isOpenInitial,
      setBodyLocked = _ref.setBodyLocked,
      searchType = _ref.searchType,
      _ref$isWhiteLabel = _ref.isWhiteLabel,
      isWhiteLabel = _ref$isWhiteLabel === void 0 ? false : _ref$isWhiteLabel,
      renderPopupComponent = _ref.renderPopupComponent;

  var _useCigarette = (0, _context.useCigarette)(),
      _useCigarette$state = _useCigarette.state,
      isMobile = _useCigarette$state.isMobile,
      isWizard = _useCigarette$state.isWizard;

  var touristsData = (0, _formik.useField)(name);

  var _touristsData = _slicedToArray(touristsData, 3),
      touristsValue = _touristsData[0].value,
      _meta = _touristsData[1],
      setValue = _touristsData[2].setValue;

  var _useField = (0, _formik.useField)(_constants.FIELD_NAMES.datepicker),
      _useField2 = _slicedToArray(_useField, 1),
      dateValue = _useField2[0].value;

  if (isWizard && !dateValue) {
    return null;
  }

  var handleAdults = function handleAdults(value) {
    setValue(_objectSpread(_objectSpread({}, touristsValue), {}, {
      adults: value
    }));
    sessionStorage.setItem('adultsValue', "".concat(value));
  };

  var handleKids = function handleKids(value) {
    setValue(_objectSpread(_objectSpread({}, touristsValue), {}, {
      kids: value
    }));
    sessionStorage.setItem('kidsValue', "".concat(JSON.stringify(value)));
  };

  var maxValue = searchType === 'hotel' ? 12 : 4;
  var maxChildren = searchType === 'hotel' ? 5 : 3;
  return /*#__PURE__*/_react["default"].createElement(_TouristsPicker["default"], {
    withDropdown: !isWizard,
    isMobile: isMobile,
    isWizard: isWizard,
    adultsValue: touristsValue.adults,
    kidsValue: touristsValue.kids,
    onChangeAdults: handleAdults,
    onChangeKids: handleKids,
    className: className,
    variant: variant,
    isOpenInitial: isOpenInitial,
    setBodyLocked: setBodyLocked,
    searchType: searchType,
    isWhiteLabel: isWhiteLabel,
    maxValue: maxValue,
    maxChildren: maxChildren,
    renderPopupComponent: renderPopupComponent
  });
};

exports.FormTouristsPicker = FormTouristsPicker;